import {Injectable} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {MatSnackBar} from '@angular/material';
import {interval} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PwaService {

  constructor(private updates: SwUpdate, private snackbar: MatSnackBar) {}

  public startUpdateChecks() {
    if ('serviceWorker' in navigator && environment.production) {
      this.checkForUpdate();
      interval(30000).subscribe(() => this.checkForUpdate());

      this.updates.available.subscribe(() => {
        console.log('PWA update available.');
        const snack = this.snackbar.open('Une mise à jour est disponible', 'Recharger');
        snack.onAction().subscribe(() => window.location.reload());
      });
    }
  }

  private checkForUpdate() {
    return this.updates.checkForUpdate()
    .then(() => console.log('Checking for PWA updates..'));
  }
}
